export const serviceMenus = () => ({
    id: `main-menu-2-all`,
    path: '/management/service/cma/tickets',
    label: 'Service',
    Description: 'Support Desk is a centralized hub for efficient and effective handling of customer inquiries, providing prompt assistance and resolving issues to ensure exceptional customer support.',
    isEnabled: true,
    svg: (
        <svg className="h-5 w-5 mr-1" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <g id="SVGRepo_bgCarrier" strokeWidth="0"></g>
            <g id="SVGRepo_tracerCarrier" strokeLinecap="round" strokeLinejoin="round"></g>
            <g id="SVGRepo_iconCarrier">
                <path fill="#ffffff" fillRule="evenodd" clipRule="evenodd" d="M17 2a1 1 0 0 1 1 1v18a1 1 0 0 1-1 1H7a1 1 0 0 1-1-1V3a1 1 0 0 1 1-1h10zm-3.75 8h-2.5V5h2.5v5zm-3.5 6h7v-2.5h-7v2.5zM8 16h1.75v2.5H8V16zm7 0h1.75v2.5H15V16z" />
            </g>
        </svg>
    ),

    subMenu: [
        {
            id: `main-menu-2-all`,
            label: 'CMA',
            path: '/management/service/cma/tickets',
            isEnabled: true,
            svg: (
                <svg className="h-5 w-5 mr-1" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <g id="SVGRepo_bgCarrier" strokeWidth="0"></g>
                    <g id="SVGRepo_tracerCarrier" strokeLinecap="round" strokeLinejoin="round"></g>
                    <g id="SVGRepo_iconCarrier">
                        <path fillRule="evenodd" clipRule="evenodd" d="M17.5 3.5h-11v17h11v-17zm-1 2h-9v13h9v-13zm-1 2h-7v9h7v-9zm-7 1h7v1h-7v-1zm0 2h7v1h-7v-1zm0 2h5v1h-5v-1zm9-6.5l-3 3 1.5 1.5 3-3-1.5-1.5z" fill="#007BFF"></path>
                    </g>
                </svg>
            ),

            subMenu: [
                {
                    id: `coln-1-collections`,
                    label: 'Service Requests',
                    path: '/management/service/cma/service-requests',
                    isEnabled: true,
                    svg: (
                        <svg className="h-5 w-5 mr-1" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <g id="SVGRepo_bgCarrier" strokeWidth="0"></g>
                            <g id="SVGRepo_tracerCarrier" strokeLinecap="round" strokeLinejoin="round"></g>
                            <g id="SVGRepo_iconCarrier">
                                <path fillRule="evenodd" clipRule="evenodd" d="M17.5 3.5h-11v17h11v-17zm-1 2h-9v13h9v-13zm-1 2h-7v9h7v-9zm-7 1h7v1h-7v-1zm0 2h7v1h-7v-1zm0 2h5v1h-5v-1zm9-6.5l-3 3 1.5 1.5 3-3-1.5-1.5z" fill="#007BFF"></path>
                            </g>
                        </svg>
                    ),
                },
                {
                    id: `coln-1-collections`,
                    label: 'Tickets',
                    path: '/management/service/cma/tickets',
                    isEnabled: true,
                    svg: (
                        <svg className="h-5 w-5 mr-1" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <g id="SVGRepo_bgCarrier" strokeWidth="0"></g>
                            <g id="SVGRepo_tracerCarrier" strokeLinecap="round" strokeLinejoin="round"></g>
                            <g id="SVGRepo_iconCarrier">
                                <path fillRule="evenodd" clipRule="evenodd" d="M18 3H6c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h12c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm-2 14H8v-2h8v2zm0-4H8v-2h8v2zm-4-5.5a.75.75 0 0 1 .75.75.75.75 0 0 1-.75.75.75.75 0 0 1-.75-.75.75.75 0 0 1 .75-.75zm-1 4h2V8h-2v3.5z" fill="#007BFF"></path>
                            </g>
                        </svg>
                    ),
                }
            ],
        },
        {
            id: `main-menu-2-all`,
            label: 'PSA',
            path: '/management/service/psa/projects',
            isEnabled: true,
            svg: (
                <svg className="h-5 w-5 mr-1" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <g id="SVGRepo_bgCarrier" strokeWidth="0"></g>
                    <g id="SVGRepo_tracerCarrier" strokeLinecap="round" strokeLinejoin="round"></g>
                    <g id="SVGRepo_iconCarrier">
                        <path fillRule="evenodd" clipRule="evenodd" d="M6 2h12c1.1 0 2 .9 2 2v16c0 1.1-.9 2-2 2H6c-1.1 0-2-.9-2-2V4c0-1.1.9-2 2-2zm1 3h10v2H7V5zm0 4h10v2H7V9zm0 4h10v2H7v-2zm0 4h5v2H7v-2z" fill="#007BFF"></path>
                    </g>
                </svg>
            ),

            subMenu: [
                {
                    id: `coln-1-collections`,
                    label: 'Projects',
                    path: '/management/service/psa/projects',
                    isEnabled: true,
                    svg: (
                        <svg className="h-5 w-5 mr-1" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <g id="SVGRepo_bgCarrier" strokeWidth="0"></g>
                            <g id="SVGRepo_tracerCarrier" strokeLinecap="round" strokeLinejoin="round"></g>
                            <g id="SVGRepo_iconCarrier">
                                <path fillRule="evenodd" clipRule="evenodd" d="M6 2h12c1.1 0 2 .9 2 2v16c0 1.1-.9 2-2 2H6c-1.1 0-2-.9-2-2V4c0-1.1.9-2 2-2zm1 3h10v2H7V5zm0 4h10v2H7V9zm0 4h10v2H7v-2zm0 4h5v2H7v-2z" fill="#007BFF"></path>
                            </g>
                        </svg>
                    ),
                },
                {
                    id: `coln-1-collections`,
                    label: 'Resource',
                    path: '/management/service/psa/resources',
                    isEnabled: true,
                    svg: (
                        <svg className="h-5 w-5 mr-1" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <g id="SVGRepo_bgCarrier" strokeWidth="0"></g>
                            <g id="SVGRepo_tracerCarrier" strokeLinecap="round" strokeLinejoin="round"></g>
                            <g id="SVGRepo_iconCarrier">
                                <path fillRule="evenodd" clipRule="evenodd" d="M20 3H4c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm-1 4H5v10h14V7zM6 8h8v2H6V8zm0 4h8v2H6v-2zm0 4h8v2H6v-2z" fill="#007BFF"></path>
                            </g>
                        </svg>
                    ),
                },
                {
                    id: `coln-1-collections`,
                    label: 'Resource Profile',
                    path: '/management/service/psa/resource-profiles',
                    isEnabled: true,
                    svg: (
                        <svg className="h-5 w-5 mr-1" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <g id="SVGRepo_bgCarrier" strokeWidth="0"></g>
                            <g id="SVGRepo_tracerCarrier" strokeLinecap="round" strokeLinejoin="round"></g>
                            <g id="SVGRepo_iconCarrier">
                                <path fillRule="evenodd" clipRule="evenodd" d="M20 3H4c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm-1 4H5v10h14V7zM6 8h8v2H6V8zm0 4h8v2H6v-2zm0 4h8v2H6v-2z" fill="#007BFF"></path>
                            </g>
                        </svg>
                    ),
                },
                {
                    id: `coln-1-Categories`,
                    label: 'Board',
                    path: '/management/service/psa/boards',
                    isEnabled: true,
                    svg: (
                        <svg className="h-5 w-5 mr-1" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <g id="SVGRepo_bgCarrier" strokeWidth="0"></g>
                            <g id="SVGRepo_tracerCarrier" strokeLinecap="round" strokeLinejoin="round"></g>
                            <g id="SVGRepo_iconCarrier">
                                <path fillRule="evenodd" clipRule="evenodd" d="M20 3H4c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm-1 4H5v10h14V7zm-7 1.5h4v-1h-4v1zm-4 2h8v-1H8v1zm4 2h4v-1h-4v1zm-4 2h8v-1H8v1zm4 2h4v-1h-4v1z" fill="#007BFF"></path>
                            </g>
                        </svg>
                    ),
                },
                {
                    id: `coln-1-Categories`,
                    label: 'Disptach Board',
                    path: '/management/service/psa/disptach-boards',
                    isEnabled: true,
                    svg: (
                        <svg className="h-5 w-5 mr-1" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <g id="SVGRepo_bgCarrier" strokeWidth="0"></g>
                            <g id="SVGRepo_tracerCarrier" strokeLinecap="round" strokeLinejoin="round"></g>
                            <g id="SVGRepo_iconCarrier">
                                <path fillRule="evenodd" clipRule="evenodd" d="M20 3H4c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm-1 4H5v10h14V7zm-7 1.5h4v-1h-4v1zm-4 2h8v-1H8v1zm4 2h4v-1h-4v1zm-4 2h8v-1H8v1zm4 2h4v-1h-4v1z" fill="#007BFF"></path>
                            </g>
                        </svg>
                    ),
                },
                {
                    id: `coln-1-Categories`,
                    label: 'Resource Month',
                    path: '/management/service/psa/resource-months',
                    isEnabled: true,
                    svg: (
                        <svg className="h-5 w-5 mr-1" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <g id="SVGRepo_bgCarrier" strokeWidth="0"></g>
                            <g id="SVGRepo_tracerCarrier" strokeLinecap="round" strokeLinejoin="round"></g>
                            <g id="SVGRepo_iconCarrier">
                                <path fillRule="evenodd" clipRule="evenodd" d="M4 5.5h16v13H4v-13zm1 1v11h14v-11H5z" fill="#007BFF"></path>
                                <path d="M10 15h4v1h-4v-1zM10 13h4v1h-4v-1zM10 11h4v1h-4v-1zM10 9h4v1h-4V9zM7 15h2v1H7v-1zM7 13h2v1H7v-1zM7 11h2v1H7v-1zM7 9h2v1H7V9z" fill="#007BFF"></path>
                            </g>
                        </svg>
                    ),
                },
                {
                    id: `coln-1-Categories`,
                    label: 'Expenses',
                    path: '/management/service/psa/expenses',
                    isEnabled: true,
                    svg: (
                        <svg className="h-5 w-5 mr-1" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <g id="SVGRepo_bgCarrier" strokeWidth="0"></g>
                            <g id="SVGRepo_tracerCarrier" strokeLinecap="round" strokeLinejoin="round"></g>
                            <g id="SVGRepo_iconCarrier">
                                <path fillRule="evenodd" clipRule="evenodd" d="M20 3h-3V2H7v1H4c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm-1 14H5V7h14v10zm-9-5h4v1h-4v-1zm0 2h4v1h-4v-1zm0 2h4v1h-4v-1z" fill="#007BFF"></path>
                            </g>
                        </svg>
                    ),
                }
            ],
        },
        {
            id: `main-menu-2-all`,
            label: 'ESA',
            path: '/management/service/esa/evaluations',
            isEnabled: true,
            svg: (
                <svg className="h-5 w-5 mr-1" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <g id="SVGRepo_bgCarrier" strokeWidth="0"></g>
                    <g id="SVGRepo_tracerCarrier" strokeLinecap="round" strokeLinejoin="round"></g>
                    <g id="SVGRepo_iconCarrier">
                        <path fillRule="evenodd" clipRule="evenodd" d="M20 3h-3V2H7v1H4c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm-1 14H5V7h14v10zm-6-4h-4v-1h4v1zm0 2h-4v-1h4v1zm0 2h-4v-1h4v1z" fill="#007BFF"></path>
                    </g>
                </svg>
            ),

            subMenu: [
                {
                    id: `coln-1-collections`,
                    label: 'Evaluation',
                    path: '/management/service/esa/evaluations',
                    isEnabled: true,
                    svg: (
                        <svg className="h-5 w-5 mr-1" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <g id="SVGRepo_bgCarrier" strokeWidth="0"></g>
                            <g id="SVGRepo_tracerCarrier" strokeLinecap="round" strokeLinejoin="round"></g>
                            <g id="SVGRepo_iconCarrier">
                                <path fillRule="evenodd" clipRule="evenodd" d="M20 3h-3V2H7v1H4c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm-1 14H5V7h14v10zm-6-4h-4v-1h4v1zm0 2h-4v-1h4v1zm0 2h-4v-1h4v1z" fill="#007BFF"></path>
                            </g>
                        </svg>
                    ),
                }
            ],
        }
    ],
}
)
